import { inject, Injectable } from '@angular/core';

import { SignageConfigurationModel } from '../../config/models';
import { DiningSlideBuilder } from '../../slides/dining-slide.builder';
import { RuntimeSlideModel } from '../../slides/models';
import { BuildContextModel, DiningFeedModel, FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class DiningContentProvider implements ContentProvider<DiningFeedModel> {
  private readonly builder = inject(DiningSlideBuilder);

  public readonly kind = ContentKind.Dining;
  public readonly tier = RefreshTier.Main;
  public readonly order = 20;
  public readonly presentation = PresentationSlot.Playlist;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public async fetch(context: FetchContextModel): Promise<DiningFeedModel[]> {
    const [meals, locations] = await Promise.all([
      context.source.loadMeals(context.config.channel, context.clock.today(context.config.community.timezone), context.signal),
      context.source.loadDiningLocations(context.config.channel, context.signal)
    ]);

    return [{ meals, locations }];
  }

  public toSlides(items: DiningFeedModel[], context: BuildContextModel): RuntimeSlideModel[] {
    return items.flatMap(item => this.builder.build(item.meals, item.locations, context.config));
  }
}
